"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonGroup = _interopRequireDefault(require("@material-ui/core/ButtonGroup"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _UploadDropzone = _interopRequireDefault(require("../Upload/UploadDropzone"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    borderRadius: 0,
    margin: props => {
      return theme.spacing(-1 * props.spacing / 2);
    }
  },
  group: {
    flexDirection: props => {
      return props.flexDirection;
    },
    alignItems: props => {
      return props.alignItems;
    }
  },
  button: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "none",
    letterSpacing: 0,
    borderRadius: 1,
    minWidth: theme.spacing(12),
    minHeight: theme.spacing(5),
    margin: props => {
      return theme.spacing(props.spacing / 2);
    },
    "&[data-size=large]": {
      minHeight: theme.spacing(7)
    },
    "&[data-variant=text]": {
      fontWeight: "normal"
    }
  },
  icon: {
    marginRight: theme.spacing(1),
    "& + $label": {
      marginRight: theme.spacing(1)
    }
  },
  label: {}
}));

const UploadButton = ({
  accept,
  multiple,
  onUpload,
  children
}) => {
  return _react.default.createElement(_UploadDropzone.default, {
    multiple: multiple,
    accept: accept,
    onUpload: onUpload
  }, children);
};

const DefaultButton = (_ref) => {
  let icon = _ref.icon,
      label = _ref.label,
      title = _ref.title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      spacing = _ref.spacing,
      _ref$disableElevation = _ref.disableElevation,
      disableElevation = _ref$disableElevation === void 0 ? true : _ref$disableElevation,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "outlined" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, ["icon", "label", "title", "color", "spacing", "disableElevation", "variant", "size"]);

  const classes = useStyles({
    spacing
  });
  return _react.default.createElement(_Button.default, _extends({}, props, {
    type: "button",
    "data-size": size,
    "data-variant": variant,
    disableElevation: disableElevation,
    color: color,
    variant: variant,
    size: size,
    className: classes.button
  }), icon && _react.default.createElement(_Icon.default, {
    className: classes.icon
  }, icon), _react.default.createElement("b", {
    className: classes.label
  }, label || title));
};

const LayoutButtons = (_ref2) => {
  let className = _ref2.className,
      buttonGroupProps = _ref2.buttonGroupProps,
      buttonTemplate = _ref2.buttonTemplate,
      buttonProps = _ref2.buttonProps,
      _ref2$buttons = _ref2.buttons,
      buttons = _ref2$buttons === void 0 ? [] : _ref2$buttons,
      props = _objectWithoutPropertiesLoose(_ref2, ["className", "buttonGroupProps", "buttonTemplate", "buttonProps", "buttons"]);

  const spacing = buttonGroupProps.spacing || props.spacing;
  const flexDirection = buttonGroupProps.flexDirection || props.flexDirection;
  const alignItems = buttonGroupProps.alignItems || props.alignItems;
  buttonGroupProps = _extends({}, buttonGroupProps, {
    spacing: spacing,
    fullWidth: props.fullWidth || buttonGroupProps.fullWidth
  });
  buttonProps = _extends({}, buttonProps, {
    spacing: spacing,
    variant: props.variant || buttonProps.variant || buttonGroupProps.variant,
    size: props.size || buttonProps.size || buttonGroupProps.size
  });
  const classes = useStyles({
    spacing,
    flexDirection,
    alignItems
  });

  if (!buttons.length) {
    return null;
  }

  let ButtonTemplate;

  if (buttonTemplate) {
    ButtonTemplate = buttonTemplate;
  } else {
    ButtonTemplate = DefaultButton;
  }

  return _react.default.createElement("div", {
    className: className || classes.root
  }, _react.default.createElement(_ButtonGroup.default, _extends({}, buttonGroupProps, {
    color: "primary",
    className: classes.group
  }), buttons && buttons.map((_ref3, index) => {
    let onClick = _ref3.onClick,
        onUpload = _ref3.onUpload,
        button = _objectWithoutPropertiesLoose(_ref3, ["onClick", "onUpload"]);

    if (onUpload) {
      return _react.default.createElement(UploadButton, _extends({}, button, {
        template: buttonTemplate,
        onUpload: onUpload,
        key: index
      }), _react.default.createElement(ButtonTemplate, _extends({}, buttonProps, button, {
        template: buttonTemplate,
        key: index
      })));
    }

    return _react.default.createElement(ButtonTemplate, _extends({}, buttonProps, button, {
      template: buttonTemplate,
      onClick: onClick,
      key: index
    }));
  })));
};

LayoutButtons.defaultProps = {
  buttonGroupProps: {
    "fullWidth": false,
    "variant": "outlined",
    "size": "large",
    "spacing": 1
  },
  buttonProps: {
    "variant": "outlined",
    "size": "large",
    "spacing": 1
  }
};
LayoutButtons.propTypes = process.env.NODE_ENV !== "production" ? {
  buttons: _propTypes.default.array,
  buttonGroupProps: _propTypes.default.object,
  buttonProps: _propTypes.default.object
} : {};
var _default = LayoutButtons;
exports.default = _default;
module.exports = exports.default;